import React from "react";
import { Typography, Grid, Dialog, DialogContent, DialogActions, Divider, CircularProgress } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import '../style/common.css';
import * as Styled from '../components/styled-components/Styled-Components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RemoveDialog = ({ openDialog, onClose, cardContent, onSave, isLoading = false }) => {
    const navigate = useNavigate();
    const { t } = useTranslation('common');

  return (
    <>
       <Dialog
        open={openDialog}
        onClose={onClose}
        className="small-dialog dialog-box"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        >
            <DialogContent className="content-dialog">
            <div className='action-icon1'>
                <DeleteIcon sx={{fontSize: 35, borderRadius:"50%", color:"#fff"}} />
            </div>
            <Typography  className="md-bold">{cardContent}</Typography>
            </DialogContent>
            <Divider />
            <DialogActions>
            <Grid container spacing={2} style={{justifyContent:  'center', marginBottom: 20}}>
                <Grid item xs={12} sm={6} xl={3} lg={3} md={3}>
                        <Styled.PrimaryButton
                            type='submit'
                            variant="contained"
                            sx={{ mt: 3, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => onSave()}
                        >
                             {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t('Deleting...')}</span></>) : <span>{t('Delete')}</span>}
                        </Styled.PrimaryButton>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={3} lg={3} md={3}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => {onClose()}}
                        >
                            {t('Cancel')}
                        </Styled.CancelButton>
                    </Grid>
                    
                </Grid>
            </DialogActions>
        </Dialog>
    </>
       
  );
};

export default RemoveDialog;
